import Backbone from '@polleverywhere/backbone'
import env from '@polleverywhere/core/lib/env'
import Tpl from './tpl.hamlc'

/**
 * Returns the i18n arguments to format messages for web responses.
 */
function i18nWebArguments () {
  const loginText = this.i18n({
    id: 'poll_inst_login',
    default: 'Log in',
    description: 'Poll instruction: **Log in** to activate'
  })

  const presenterURL = env
    .get('mobile_url')
    .path(this.model.presenter.get('login'))
  let presenterHumanURL = ''
  try {
    presenterHumanURL = presenterURL.host() + '/' + presenterURL.path()
  } catch (e) {
    if (window.Rollbar) {
      window.Rollbar.error(`Something went wrong: ${JSON.stringify(this.model.presenter)}`, e)
    }
  }

  return {
    url: `<a class="url emphasis" target="_blank" rel="noopener" href="${presenterURL.toString()}">${presenterHumanURL}</a>`,
    login: `<span class="deactivated-login"><span class="instructions-login emphasis">${loginText}</span></span>`
  }
}

export default class Inactive extends Backbone.View {
  get className () { return 'inactive' }

  get events () {
    return {
      'click .deactivated-login': 'login'
    }
  }

  /**
   * @param {Object} options
   * @param {Backbone.Model} options.model Activity model
   * @param {Backbone.Router} options.app Router instance
   */
  initialize (options = {}) {
    if (!options.i18n) {
      console.error('i18n is required.')
    }

    this.i18n = options.i18n
    this.render = this.render.bind(this)
    this.login = this.login.bind(this)
  }

  render () {
    const args = i18nWebArguments.call(this)
    const html = this.i18n('Poll not active. {login} to activate', args)
    this.$el.html(Tpl())
    this.$('.inactive--text').html(html)
    return this
  }

  login () {
    this.trigger('login')
  }
}
